// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsEmrClustersIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-emr-clusters_svga)" d="M40 0H0v40h40z" />
    <svg width={28} height={28} x={6} y={6} viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M22.27 15.6a.63.63 0 0 0-.56.63v1.9l-1.48-.5 1.71-2.5zm.72 5h3.74v-3.74h-3.74zm-2.78 3.28v-1.53a.64.64 0 0 0-.64-.64h-2.14l2.05-2.98 2.23.74v1.77c0 .35.29.64.64.64h.53zm-5.02 2.85h3.74v-3.74H15.2zm-9.82-6.69c-2.55 0-4.03-.73-4.1-1.04v-8.33c1.05.51 2.6.75 4.1.75s3.04-.24 4.1-.75V19c-.07.31-1.55 1.04-4.1 1.04M9.35 9.25c-.38.35-1.78.9-3.98.9s-3.6-.55-3.99-.9c.39-.35 1.78-.9 3.99-.9s3.6.55 3.98.9m5.84-4.24h3.74V1.27h-3.74zm7.7 1.11h-.54a.64.64 0 0 0-.64.64v1.77l-2.23.74-2.05-2.98h2.14c.35 0 .64-.29.64-.64V4.12zm.1 5.02h3.74V7.4h-3.74zm-2.76-.77 1.48-.5v1.9c0 .33.25.58.56.62l-.33.48zm-9.5 4.1v-.94l8.24-2.74 2.2 3.21-2.2 3.21zm3.45-8.32q.15.13.38.14h1.33l2.33 3.4-7.48 2.5V9.4l-.02-.14.02-.14h-.03L10.67 9zm.38 15.56a.6.6 0 0 0-.38.14l-3.45-2.8V15.8l7.5 2.5-2.34 3.41zm9.24-9.3h3.56c.36 0 .64-.28.64-.64v-5a.64.64 0 0 0-.64-.65h-2.38c-1.67-1.3-4-3.02-4.77-3.58V.64a.64.64 0 0 0-.64-.64h-5.01a.64.64 0 0 0-.64.64v4.08L9.83 8.04c-1.03-.65-2.78-.96-4.46-.96-2.42 0-5.02.64-5.34 2.03H0l.02.14L0 9.4V19c0 1.6 2.78 2.32 5.37 2.32 1.83 0 3.75-.37 4.73-1.14l3.82 3.1v4.08c0 .36.28.64.64.64h5c.36 0 .65-.28.65-.64v-1.9c.76-.56 3.1-2.28 4.77-3.58h2.38c.36 0 .64-.29.64-.64v-5.01a.64.64 0 0 0-.64-.64H23.8L22.71 14z"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-emr-clusters_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsEmrClusters",
);
export default AwsEmrClustersIcon;
